module.exports = __webpack_public_path__ + "img/arrange-circle.a60f3e62.svg";